import RootElementsBehavior from './RootElementsBehavior';


/**
 * @type { import('didi').ModuleDeclaration }
 */
export default {
  __init__: [ 'rootElementsBehavior' ],
  rootElementsBehavior: [ 'type', RootElementsBehavior ]
};
